import { Link } from 'react-router-dom';
import type { MangaItem } from '@/mocks/comics';

interface ComicsCardProps {
  manga: MangaItem;
  size?: 'normal' | 'large';
}

export default function ComicsCard({ manga, size = 'normal' }: ComicsCardProps) {
  return (
    <Link
      to={`/article/${manga.id}`}
      className="group block"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <article className="flex flex-col gap-3">
        <div
          className={`relative overflow-hidden rounded-lg bg-background-200 ${
            size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
          }`}
        >
          <img
            src={manga.cover}
            alt={manga.title}
            title={`${manga.title} - 韩漫在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
            {manga.featured && (
              <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                推荐
              </span>
            )}
            {manga.hot && (
              <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                热门
              </span>
            )}
          </div>
          <div className="absolute bottom-2 right-2 px-2 py-0.5 text-[10px] font-medium bg-black/60 text-background-50 rounded-full whitespace-nowrap">
            {manga.status}
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
            {manga.title}
          </h3>
          <p className="text-xs text-foreground-500 line-clamp-1">
            {manga.author}
          </p>
          <div className="flex items-center gap-3 text-xs text-foreground-400 mt-0.5">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-star-fill text-accent-400 text-[10px]"></i>
              </span>
              {manga.rating}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-eye-line text-[10px]"></i>
              </span>
              {manga.views >= 10000
                ? `${(manga.views / 10000).toFixed(0)}万`
                : manga.views}
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
}